import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getOperationEntitiesByGroupForDropDown,
    GetRouteEmployeeDetailsReport
};

async function getOperationEntitiesByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function GetRouteEmployeeDetailsReport(operationEntityID, date) {
    var newModel = {
        operationEntityID: parseInt(operationEntityID),
        date: date
    }
    const response = await CommonPost('/api/RouteEmployeeDetailsReport/GetRouteEmployeeDetailsReport', null, newModel);
    return response.data;
}

